// dependencies
import React, { useEffect, useState } from 'react'
import ReactJson from 'react-json-view'

// components
import { BUTTON_THEME, CircularLoader, Switch, Table } from '@st-operations/uikit/src/v2/index.js'
import Header from '_components/header/index.jsx'

//hooks
import { useRetractSidebar } from '_hooks'

// services
import { getEntity } from '_services/ttd-audiences.js'

// constants
import { ENTITY, TABLE_COLUMNS_SINGULAR } from '../constants'

// styles
import './styles.scss'
import { logErrorAsync } from '../../../lib/utility'

const TTDAudience = (props) => {
  const { id } = props.match.params
  const [data, setData] = useState(null)
  const [isJSONView, setIsJSONView] = useState(false)

  useRetractSidebar()

  const loadData = async () => {
    try {
      const data = await getEntity(ENTITY, id)
      setData(data)
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  useEffect(() => {
    if (!data) {
      loadData()
    }
  }, [data])

  const handleExit = () => props.history.push(`/${ENTITY}`)

  const headerActions = [
    {
      children: 'Exit',
      onClick: handleExit,
      theme: BUTTON_THEME.GHOST,
    },
  ]

  if (!data) {
    return (
      <div className="ttd-audience__loading">
        <CircularLoader />
      </div>
    )
  }

  return (
    <div id="ttd-audience-page" className="ttd-audience">
      <Header actions={headerActions} title={data.displayName} back={handleExit} />

      <h2 className="ttd-audience__title">{data.displayName}</h2>
      <h3 className="ttd-audience__description">{data.description}</h3>

      <div className="ttd-audience__list-header-ds">
        <h4>Information</h4>
      </div>
      <dl className="ttd-audience__list">
        <div className="ttd-audience__item">
          <dt>Buyable:</dt>
          <dd>{data.buyable.toString()}</dd>
        </div>
        <div className="ttd-audience__item">
          <dt>Provider Element ID:</dt>
          <dd>{data.providerElementId}</dd>
        </div>
        <div className="ttd-audience__item">
          <dt>Parent Element ID:</dt>
          <dd>
            <a href={`/${ENTITY}/${data.parentElementId}`}>{data.parentElementId}</a>
          </dd>
        </div>
        <div className="ttd-audience__item">
          <dt>Received IDs Count:</dt>
          <dd>{data.receivedIDsCount}</dd>
        </div>
        <div className="ttd-audience__item">
          <dt>Active IDs Count:</dt>
          <dd>{data.activeIDsCount}</dd>
        </div>
        <div className="ttd-audience__item">
          <dt>Last Updated At UTC:</dt>
          <dd>{data.lastUpdatedAtUTC}</dd>
        </div>
      </dl>

      <div className="ttd-audience__batches-wrapper">
        <h3 className="ttd-audience__batches-label">Data Rate Batches</h3>
        <div className="ttd-audience__json-switch">
          <Switch checked={isJSONView} onChange={() => setIsJSONView((state) => !state)} />
          <span className="ttd-audience__json-switch-label">JSON View</span>
        </div>
      </div>
      <Choose>
        <When condition={isJSONView}>
          <ReactJson name={false} displayDataTypes={false} src={data.dataRates} />
        </When>
        <Otherwise>
          <Table columns={TABLE_COLUMNS_SINGULAR} data={data.dataRates} />
        </Otherwise>
      </Choose>
    </div>
  )
}

export default TTDAudience
